import MigrationManagement from '@/views/Admin/MigrationManagement.vue';
import TenantManagement from '@/views/Admin/TenantManagement.vue';
import SystemLogs from '@/views/Admin/SystemLogs.vue';
import EmailSettings from '@/views/Admin/EmailSettings.vue';
import EmailLog from '@/views/Admin/EmailLog.vue';
import RoleClaimsAdmin from '@/views/Admin/RoleClaimsAdmin.vue';
import Registrations from '@/views/admin/Registrations.vue';

const AdminRoutes = [
    {
        path: "/admin/migrations",
        name: "Admin - Migrations",
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        components: {
            page: MigrationManagement
        }
    },
    {
        path: "/admin/tenants",
        name: "Admin - Tenants",
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        components: {
            page: TenantManagement
        }
    },
    {
        path: "/admin/logs",
        name: "Admin - System Logs",
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        components: {
            page: SystemLogs
        }
    },
    {
        path: "/admin/email/settings",
        name: "Admin - Email Settings",
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        components: {
            page: EmailSettings
        }
    },
    {
        path: "/admin/email/log",
        name: "Admin - Email Log",
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        components: {
            page: EmailLog
        }
    },
    {
        path: "/admin/roles",
        name: "Admin - Roles & Claims",
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        components: {
            page: RoleClaimsAdmin
        }
    },
    {
        path: "/admin/registrations",
        name: "Admin - Registrations",
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        components: {
            page: Registrations
        }
    }
];

export default AdminRoutes;
